/**
 * Created by Dhanya Akhil on 3/1/2017.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { UserlockRoutingModule } from './userlock-routing.module';
import { UserlockComponent } from './components/userlock.component';
import { UserlockService } from "./services/userlock.service";

@NgModule({
  imports: [
    CommonModule,
    UserlockRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule.forRoot(),
    TranslateModule.forChild()
  ],
  declarations: [UserlockComponent],
  exports:[FormsModule,ReactiveFormsModule],
  providers: [UserlockService]
})
export class UserlockModule {
}
